import {auth, db} from '../../firebase/index';

export const authentication = () => {
    return async (dispatch, getState) => {
        auth.onAuthStateChanged(async (user) => {
            if (user) {
                db.collection('users').doc(user.uid).get().then(snapshot => {
                    const userValue = snapshot.data();
                    const userState = {
                        birthday: (userValue.birthday) ? userValue.birthday : "",
                        block_users: (userValue.block_users) ? userValue.block_users : {},
                        gender: (userValue.gender) ? userValue.gender: "",
                        prefecture: (userValue.prefecture) ? userValue.prefecture: "",
                        nick_name: userValue.nick_name,
                        isLoggedIn: true,
                        isAgreed: userValue.is_agreed,
                        userId: user.uid,
                    };
                    dispatch(updateUserState(userState));
                }).catch((error) => {
                    console.error(error)
                })
            } else {
                auth.signInAnonymously().then(async (credential) => {
                    const user = credential.user;

                    // Set initial value to the new user
                    await db.collection('users').doc(user.uid).set({
                        nick_name: "ゲスト",
                        is_agreed: false,
                        id: user.uid
                    });
                })
            }
        })
    }
};

export const agreeServiceOfTerms = () => {
    return async (dispatch, getState) => {
        const userId = getState().user.userId;
        await db.collection('users').doc(userId).update({is_agreed: true});
        dispatch(updateUserState({isAgreed: true}))
    }
};

export const updateUserProfile = (newValue) => {
    return async (dispatch, getState) => {
        const userId = getState().user.userId;
        await db.collection('users').doc(userId).update(newValue);
        dispatch(updateUserState(newValue))
    }
};

// Define Action Creators
export const UPDATE_USER_STATE = "UPDATE_USER_STATE";
export const updateUserState = (userState) => {
    return {
        type: "UPDATE_USER_STATE",
        payload: userState
    }
};
